import { useContext, createContext } from 'react';

export const GlobalWindowContext = createContext<Window | null | undefined>(undefined);

const useWindow = (overrideNativeWindow?: boolean): Window | null | undefined => {
  const globalWindow = useContext(GlobalWindowContext);
  if (globalWindow === undefined && !overrideNativeWindow) {
    return window;
  } else {
    return useContext(GlobalWindowContext);
  }
};

export default useWindow;
